import styled from 'styled-components';

export const WidthLimiter = styled.div`
  max-width: 1000px;
  width: 100%;
`;
